import type { FC, ReactNode } from 'preact/compat';
import { useEffect } from 'preact/compat';

import { TickerStrategy } from '@stomp/stompjs';

import { websocketConnectionManager } from '../../utils';
import { StompSessionProvider } from 'react-stomp-hooks';

import { websocketUrl, widgetHeartbeatMs } from '../../../config';
import { WebSocketWrapperChildren } from './WebSocketWrapperChildren';

interface Props {
  children: ReactNode;
  token: string | null;
}

export const WebSocketWrapper: FC<Props> = ({ children, token }) => {
  useEffect(() => {
    websocketConnectionManager.registerConnection();

    return () => {
      void websocketConnectionManager.closeCurrentConnection();
    };
  }, []);

  return (
    <StompSessionProvider
      enabled={Boolean(token)}
      url={websocketUrl}
      connectHeaders={{
        Authorization: `Bearer ${token}`,
      }}
      heartbeatIncoming={Number(widgetHeartbeatMs)}
      heartbeatOutgoing={Number(widgetHeartbeatMs)}
      heartbeatStrategy={TickerStrategy.Interval}
    >
      <WebSocketWrapperChildren>{children}</WebSocketWrapperChildren>
    </StompSessionProvider>
  );
};
